"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformSavedStateVisibility = exports.SdPlatformOrganizationVisibility = exports.SdPlatformModelVisibility = exports.SdPlatformUserVisibility = void 0;
/**
 * Visibility for users
 */
var SdPlatformUserVisibility;
(function (SdPlatformUserVisibility) {
    /**
     * Private visibility.
     */
    SdPlatformUserVisibility["Private"] = "private";
    /**
     * Organization visibility.
     */
    SdPlatformUserVisibility["Organization"] = "organization";
    /**
     * Public visibility.
     */
    SdPlatformUserVisibility["Public"] = "public";
})(SdPlatformUserVisibility = exports.SdPlatformUserVisibility || (exports.SdPlatformUserVisibility = {}));
/**
 * Visibility for models
 */
var SdPlatformModelVisibility;
(function (SdPlatformModelVisibility) {
    /**
    * Private visibility.
    */
    SdPlatformModelVisibility["Private"] = "private";
    /**
     * Organization visibility.
     */
    SdPlatformModelVisibility["Organization"] = "organization";
    /**
     * Public visibility.
     */
    SdPlatformModelVisibility["Public"] = "public";
    /**
     * "shared" can be used for querying models only
     */
    SdPlatformModelVisibility["Shared"] = "shared";
})(SdPlatformModelVisibility = exports.SdPlatformModelVisibility || (exports.SdPlatformModelVisibility = {}));
/**
 * Visibility for organizations
 */
var SdPlatformOrganizationVisibility;
(function (SdPlatformOrganizationVisibility) {
    /**
     * Private visibility.
     */
    SdPlatformOrganizationVisibility["Private"] = "private";
    /**
     * Organization visibility.
     */
    SdPlatformOrganizationVisibility["Organization"] = "organization";
    /**
     * Public visibility.
     */
    SdPlatformOrganizationVisibility["Public"] = "public";
})(SdPlatformOrganizationVisibility = exports.SdPlatformOrganizationVisibility || (exports.SdPlatformOrganizationVisibility = {}));
/**
 * Visibility for saved states
 */
var SdPlatformSavedStateVisibility;
(function (SdPlatformSavedStateVisibility) {
    /**
     * Private visibility.
     */
    SdPlatformSavedStateVisibility["Private"] = "private";
    /**
     * Organization visibility.
     */
    SdPlatformSavedStateVisibility["Organization"] = "organization";
    /**
     * Public visibility.
     */
    SdPlatformSavedStateVisibility["Public"] = "public";
    /**
     * "shared" can be used for querying saved states only
     */
    SdPlatformSavedStateVisibility["Shared"] = "shared";
})(SdPlatformSavedStateVisibility = exports.SdPlatformSavedStateVisibility || (exports.SdPlatformSavedStateVisibility = {}));
//# sourceMappingURL=SdPlatformVisibility.js.map